(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('holiday', {
            parent: 'entity',
            url: '/holiday?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'valueconnectApp.holiday.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/holiday/holidays.html',
                    controller: 'HolidayController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'startDate,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('holiday');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('holiday.new', {
            parent: 'holiday',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/holiday/holiday-dialog.html',
                    controller: 'HolidayDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                startDate: null,
                                endDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('holiday', null, { reload: 'holiday' });
                }, function() {
                    $state.go('holiday');
                });
            }]
        })
        .state('holiday-detail', {
            parent: 'holiday',
            url: '/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'valueconnectApp.holiday.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/holiday/holiday-detail.html',
                    controller: 'HolidayDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('holiday');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Holiday', function($stateParams, Holiday) {
                    return Holiday.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('holiday.edit', {
            parent: 'holiday',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/holiday/holiday-dialog.html',
                    controller: 'HolidayDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Holiday', function(Holiday) {
                            return Holiday.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('holiday', null, { reload: 'holiday' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('holiday.delete', {
            parent: 'holiday',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/holiday/holiday-delete-dialog.html',
                    controller: 'HolidayDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Holiday', function(Holiday) {
                            return Holiday.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('holiday', null, { reload: 'holiday' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
